module.exports = __webpack_public_path__ + "static/banner_resources-10086199891d44264e8155ecb25ccb06.png";